<template>
    <vs-collapse class="collapse_p_0 p-0 py-4">
        <vs-collapse-item open>
            <div style="background: #F8F8F8; border-radius: 3px;" class="p-1" slot="header">
            <p class="text-muted">FILTER</p>
            </div>
            <div>
            <vs-checkbox v-model="classes" @change="getSchedule" class="my-3">Classes</vs-checkbox>
            <vs-checkbox v-model="course" @change="getSchedule" class="my-3">Courses</vs-checkbox>
            <!-- <vs-checkbox class="my-3">Availability</vs-checkbox> -->
            <vs-checkbox v-model="canceled" @change="getSchedule" class="my-3">Cancelled Lessons</vs-checkbox>
            </div>
        </vs-collapse-item>
    </vs-collapse>
</template>
<script>
export default {
  data () {
    return {
      classes:true,
      course:true,
      canceled:true
    }
  },
  props: {
    type:{}
  },
  methods: {
    async getSchedule () {
      const payload = {
        class: this.classes,
        course: this.course,
        canceled: this.canceled
      }

      this.$emit('filterSchedule', payload, this.type)
    }
  }

}
</script>